import privacyEn from './privacy.en.md?raw';
import privacyFa from './privacy.fa.md?raw';
import termsEn from './terms.en.md?raw';
import termsFa from './terms.fa.md?raw';

/**
 * Set to false once counsel has reviewed the texts and every [[PLACEHOLDER]]
 * is filled in (see README.md in this folder). While true, the pages show a
 * "draft under review" notice.
 */
export const LEGAL_REVIEW_PENDING = true;

export type LegalDoc = 'privacy' | 'terms';

const DOCS: Record<LegalDoc, Record<'en' | 'fa', string>> = {
  privacy: { en: privacyEn, fa: privacyFa },
  terms: { en: termsEn, fa: termsFa },
};

export function legalText(doc: LegalDoc, language: string): string {
  return DOCS[doc][language === 'fa' ? 'fa' : 'en'];
}
